import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import gameConfig from "../../../../../engines/configs/gameConfig";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import HitRobGameLayer from "../../../prefab/hitRob/HitRobGameLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FddsLosePage extends BasePopUpLayer {

    @property(cc.Node)
    nodeAd: cc.Node = null;

    start() {
        this.nodeAd.active = HitRobGameLayer.sReviveCount <= 1;
    }

    onBtnExit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
       
        this.destroyNode();
        this._carryData.parent && this._carryData.parent.exitLayer();
    }

    onBtnContinue(){
        if (!this.nodeAd.active) {
            HitRobGameLayer.sReviveCount--;
            O1HD.emit(MessageEventKind.EventName.REFRESH_HIT_ROB_REVIVE_COUNT);
            this.destroyNode();
            this._carryData.parent.resetStart();
        } else {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                HitRobGameLayer.sReviveCount = gameConfig.AD_HIT_ROB_COUNT;
                O1HD.emit(MessageEventKind.EventName.REFRESH_HIT_ROB_REVIVE_COUNT);
                this.destroyNode();
                this._carryData.parent.resetStart();
            },()=>{},null,"打劫匪复活");
        }
    }
}
